import { Observable, isObservable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

export function ReusableStreamMethod(
  target: any,
  propertyKey: string,
  descriptor: PropertyDescriptor
) {
  const old = target[propertyKey];
  let singleton;

  descriptor.value = function(...args) {
    if (!singleton) {
      const result = old.call(this, args);
      if (!isObservable(result)) {
        throw new Error('Result is not Observable');
      }
      singleton = result.pipe(publishReplay(1), refCount());
    }
    return singleton;
  };
}

export function ReusableStreamProperty(target: any, propertyKey: string): void {
  const descriptor: PropertyDescriptor = {
    get: () => descriptor.value,
    set: (v: Observable<any>) => {
      if (!isObservable(v)) {
        throw new Error(`${propertyKey} is not Observable`);
      }
      descriptor.value = v.pipe(publishReplay(1), refCount());
    }
  };

  Object.defineProperty(target, propertyKey, descriptor);
}
